import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/slice";
import userReducer from "./user/slice";
import branchReducer from "./branch/slice";
import teamReducer from "./team/slice";
import usersReduces from "./users/slice";
import posterReducer from "./poster/slice";
import spreadsheetReducer from "./spreadsheet/slice";
import topicsReducer from "./topics/slice";
import customersReducer from "./customers/slice";
import chatsReducer from "./chats/slice";
import casesReducer from "./cases/slice";
import appointmentsReducer from "./appointments/slice";
import tasksReducer from "./tasks/slice";
import { websocketMiddleware } from "./chats/middleware/websocketMiddleware";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    branch: branchReducer,
    team: teamReducer,
    users: usersReduces,
    topics: topicsReducer,
    chats: chatsReducer,
    customers: customersReducer,
    cases: casesReducer,
    appointments: appointmentsReducer,
    posters: posterReducer,
    spreadsheet: spreadsheetReducer,
    tasks: tasksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(websocketMiddleware),
});
